var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advantage"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"list flex-row"},_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"item flex-column"},[_c('div',[_vm._v(_vm._s(item.text1))]),_c('div',[_c('div',[_vm._v(_vm._s(item.text2))])])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }